import { GripNormsPanel } from "./GripNormsPanel";
import { parseGripText, useGripNorms } from "./useGripNorms";

// Compact norms hint under the EP "Handgrip strength (kg, R / L)" field.
export function GripNormsHint({ assessmentId, text }) {
  const { left, right } = parseGripText(text);
  const cmp = useGripNorms(assessmentId, left, right);
  if (!cmp) return null;
  return (
    <div className="mt-1.5">
      <GripNormsPanel cmp={cmp} compact testId="ep-grip-norms" />
    </div>
  );
}
